export default "__VITE_ASSET__994d6f50__"